// Catalogue / shop archive behaviors:
//   * client-side filter state (taxonomy checkboxes, search text, sort)
//   * apply_filters: show/hide items, dim unavailable filters, sort, count
//   * URL preset (/shop/solutions/foo) seeds checkboxes
//   * filter-clear button

import * as search_text from './lib/search-text.js';

var taxonomies = ['solution_type', 'area', 'screen_size', 'screen_orientation', 'solutions'];

var filters_pruned_once = false;
var is_shop_catalogue_page = false;
var catalogue_filter_state_key = '';

// Sidebar section labels → one pill per taxonomy when any value in that group is checked.
var catalogue_filter_groups = [
    { taxonomy: 'category', label: 'Products & services' },
    { taxonomy: 'solution_type', label: 'Type' },
    { taxonomy: 'product_area', label: 'Area in store' },
    { taxonomy: 'screen_size', label: 'Screen size' },
    { taxonomy: 'screen_orientation', label: 'Screen orientation' },
    { taxonomy: 'zd_asset_country', label: 'Country' },
    { taxonomy: 'zd_asset_city', label: 'City' }
];

function bootstrap_page_flags() {
    var $body = jQuery('body');
    is_shop_catalogue_page = $body.hasClass('woocommerce') && jQuery('.zd-item-catalogue').length > 0;
    catalogue_filter_state_key = is_shop_catalogue_page
        ? 'zd_catalogue_filters_state_v1_shop'
        : 'zd_catalogue_filters_state_v1_assets';
}

// === search input ===

// Product search haystack is built server-side (title + term slugs + term names).
// Use .attr(), not .data(): jQuery coerces values like `55" Portrait` to numbers.
function get_product_search_text(item) {
    var search = item.attr('data-search');

    if (search) {
        return search;
    }

    return String(item.find('.woocommerce-loop-product__title').text() || '');
}

function is_search_active() {
    return search_text.is_searchable(jQuery('#zd-product-search').val());
}

function apply_search_filter() {
    var search_tokens = search_text.tokens(jQuery('#zd-product-search').val());

    apply_filters();

    if (!is_search_active()) return;

    jQuery('.zd-product').each(function() {
        var $product = jQuery(this);

        var text_match = search_text.matches(get_product_search_text($product), search_tokens);

        if (text_match && $product.is(':visible')) {
            $product.show();
        } else {
            $product.hide();
        }
    });
}

// === state persistence ===

function safe_split_filter_data(data, delimiter) {
    delimiter = delimiter || ' ';

    if (typeof data === 'string') return data.split(delimiter).filter(Boolean);
    if (Array.isArray(data)) return data.map(String);
    if (data != null) return String(data).split(delimiter).filter(Boolean);
    return [];
}

function get_catalogue_filter_state() {
    var checked_filters = [];
    var seen_filters = {};

    jQuery('.catalogue-filter-item:checked').each(function() {
        var $input = jQuery(this);
        var taxonomy = String($input.data('taxonomy') || '').trim();
        var identifier = String($input.data('identifier') || '').trim();

        if (!taxonomy || !identifier) return;

        var dedupe_key = taxonomy + '::' + identifier;
        if (seen_filters[dedupe_key]) return;
        seen_filters[dedupe_key] = true;

        checked_filters.push({ taxonomy: taxonomy, identifier: identifier });
    });

    return {
        checked_filters: checked_filters,
        search_term: String(jQuery('#zd-product-search').val() || ''),
        sort_option: String(jQuery('.product-search-sort-select').val() || '')
    };
}

function sync_catalogue_filter_pair($source_input) {
    var taxonomy = String($source_input.data('taxonomy') || '').trim();
    var identifier = String($source_input.data('identifier') || '').trim();

    if (!taxonomy || !identifier) return;

    var is_checked = $source_input.is(':checked');

    jQuery('.catalogue-filter-item[data-taxonomy="' + taxonomy + '"][data-identifier="' + identifier + '"]')
        .prop('checked', is_checked);
}

function save_catalogue_filter_state() {
    try {
        window.sessionStorage.setItem(
            catalogue_filter_state_key,
            JSON.stringify(get_catalogue_filter_state())
        );
    } catch (e) {
        console.log('Could not save catalogue filter state', e);
    }
}

function load_catalogue_filter_state() {
    try {
        var raw = window.sessionStorage.getItem(catalogue_filter_state_key);
        if (!raw) return null;

        var parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;

        return parsed;
    } catch (e) {
        console.log('Could not load catalogue filter state', e);
        return null;
    }
}

function restore_catalogue_filter_state() {
    var state = load_catalogue_filter_state();
    if (!state) return false;

    jQuery('.catalogue-filter-item').prop('checked', false);

    (state.checked_filters || []).forEach(function(row) {
        var taxonomy = String(row.taxonomy || '').trim();
        var identifier = String(row.identifier || '').trim();

        if (!taxonomy || !identifier) return;

        jQuery(
            '.catalogue-filter-item[data-taxonomy="' + taxonomy + '"][data-identifier="' + identifier + '"]'
        ).prop('checked', true);
    });

    jQuery('#zd-product-search').val(String(state.search_term || ''));

    if (String(state.sort_option || '').trim() !== '') {
        jQuery('.product-search-sort-select').val(String(state.sort_option));
    }

    return true;
}

function clear_catalogue_filter_state() {
    try {
        window.sessionStorage.removeItem(catalogue_filter_state_key);
    } catch (e) {
        console.log('Could not clear catalogue filter state', e);
    }
}

function sync_catalogue_title_from_filters() {
    var $title = jQuery('.zd-shop-title-text');
    if (!$title.length) return;

    var $checked = jQuery('.catalogue-filter-item:checked').first();
    if (!$checked.length) {
        $title.text($title.data('default'));
        return;
    }

    var label = $checked.closest('label.catalogue-item-label').text().trim();
    if (!label) {
        label = $checked.siblings('label').first().text().trim();
    }
    if (!label) {
        label = $checked.closest('li.filter-item, li.nav-item').find('label').first().text().trim();
    }

    $title.text(label || $title.data('default'));
}

function clear_catalogue_filters(keep_url) {
    jQuery('input.catalogue-filter-item').prop('checked', false);
    jQuery('#zd-product-search').val('');
    if (!keep_url) {
        jQuery('.zd-shop-title-text').text(jQuery('.zd-shop-title-text').data('default'));
    }
    jQuery('.zd-search-filter-info').hide();

    var $sort = jQuery('.product-search-sort-select');
    if ($sort.length) {
        $sort.val($sort.find('option').first().val());
    }

    filters_pruned_once = false;
    clear_catalogue_filter_state();
    apply_filters(false);

    if (keep_url) {
        return;
    }

    var reset_url = is_shop_catalogue_page
        ? (window.location.origin + '/shop/')
        : (window.location.origin + window.location.pathname);
    window.history.replaceState({}, '', reset_url);
}

function clear_filters_keep_search() {
    jQuery('input.catalogue-filter-item').prop('checked', false);
    jQuery('.zd-shop-title-text').text(jQuery('.zd-shop-title-text').data('default'));
    jQuery('.zd-search-filter-info').hide();

    filters_pruned_once = false;

    if (is_shop_catalogue_page) {
        window.history.replaceState({}, '', window.location.origin + '/shop/');
    }

    apply_filters();
}

function clear_catalogue_filter_group(taxonomy) {
    taxonomy = String(taxonomy || '').trim();
    if (!taxonomy) return;

    jQuery('.catalogue-filter-item[data-taxonomy="' + taxonomy + '"]').prop('checked', false);

    var any_checked = jQuery(
        '.catalogue-filter-item:checked, .solution-types-list input:checked, .product-areas-list input:checked, .screen-sizes-list input:checked, .screen-orientations-list input:checked, .country-list input:checked, .city-list input:checked'
    ).length > 0;

    if (!any_checked) {
        if (is_search_active()) {
            clear_filters_keep_search();
        } else {
            clear_catalogue_filters();
        }
        return;
    }

    sync_catalogue_title_from_filters();
    apply_filters();
}

function render_catalogue_filter_pills() {
    var $container = jQuery('.zd-catalogue-filter-pills');
    if (!$container.length) return;

    var $pills = jQuery();

    catalogue_filter_groups.forEach(function(group) {
        var seen = {};
        var active_count = 0;

        jQuery('.catalogue-filter-item[data-taxonomy="' + group.taxonomy + '"]:checked').each(function() {
            var identifier = String(jQuery(this).data('identifier') || '').trim();
            if (!identifier) return;

            var key = group.taxonomy + '::' + identifier;
            if (seen[key]) return;
            seen[key] = true;
            active_count++;
        });

        if (active_count <= 0) return;

        var count_label = active_count === 1 ? '1 item' : active_count + ' items';
        var pill_label = group.label + ' (' + count_label + ')';

        var $pill = jQuery(
            '<button type="button" class="filter-clear active zd-filter-pill"></button>'
        );
        $pill.attr('data-filter-taxonomy', group.taxonomy);
        $pill.append('<i class="bi bi-x-circle-fill" style="opacity: 0.9;"></i> ');
        $pill.append(document.createTextNode(pill_label));
        $pills = $pills.add($pill);
    });

    $container.empty().append($pills);
}

// === apply_filters: the main render pass ===

function apply_filters(save_state) {
    if (save_state !== false) {
        save_catalogue_filter_state();
    }

    var selected_solutions = [];
    var selected_areas = [];
    var selected_categories = [];
    var selected_screen_sizes = [];
    var selected_screen_orientations = [];
    var selected_countries = [];
    var selected_cities = [];

    jQuery('.catalogue-filters ul.nav .catalogue-filter-item:checked').each(function() {
        selected_categories.push(jQuery(this).data('identifier'));
    });
    jQuery('.solution-types-list input:checked').each(function() {
        selected_solutions.push(jQuery(this).data('identifier'));
    });
    jQuery('.product-areas-list input:checked').each(function() {
        selected_areas.push(jQuery(this).data('identifier'));
    });
    jQuery('.screen-sizes-list input:checked').each(function() {
        selected_screen_sizes.push(jQuery(this).data('identifier'));
    });
    jQuery('.screen-orientations-list input:checked').each(function() {
        selected_screen_orientations.push(jQuery(this).data('identifier'));
    });
    jQuery('.country-list input:checked').each(function() {
        selected_countries.push(jQuery(this).data('identifier'));
    });
    jQuery('.city-list input:checked').each(function() {
        selected_cities.push(jQuery(this).data('identifier'));
    });

    var search_tokens = search_text.tokens(jQuery('#zd-product-search').val());
    var search_active = is_search_active();

    jQuery('.zd-filter-item').each(function() {
        var item = jQuery(this);

        var item_solutions = safe_split_filter_data(item.data('solution-type'));
        var item_areas = safe_split_filter_data(item.data('product-area'));
        var item_categories = safe_split_filter_data(item.data('category'));
        var item_screen_sizes = safe_split_filter_data(item.data('screen-size'));
        var item_screen_orient = safe_split_filter_data(item.data('screen-orientation'));
        var item_countries = safe_split_filter_data(item.data('country'));
        var item_cities = safe_split_filter_data(item.data('city'));

        var match = true;

        if (selected_categories.length > 0) {
            match = selected_categories.some(function(val) { return item_categories.includes(val); });
        }
        if (match && selected_solutions.length > 0) {
            match = selected_solutions.some(function(val) { return item_solutions.includes(val); });
        }
        if (match && selected_areas.length > 0) {
            match = selected_areas.some(function(val) { return item_areas.includes(val); });
        }
        if (match && selected_screen_sizes.length > 0) {
            var item_sizes = item_screen_sizes.map(String);
            var sel_sizes = selected_screen_sizes.map(String);

            match = sel_sizes.some(function(val) { return item_sizes.includes(val); });
        }
        if (match && selected_screen_orientations.length > 0) {
            match = selected_screen_orientations.some(function(val) { return item_screen_orient.includes(val); });
        }
        if (match && selected_countries.length > 0) {
            match = selected_countries.some(function(val) { return item_countries.includes(val); });
        }
        if (match && selected_cities.length > 0) {
            match = selected_cities.some(function(val) { return item_cities.includes(val); });
        }

        if (match && search_active) {
            match = search_text.matches(get_product_search_text(item), search_tokens);
        }

        if (match) item.show();
        else item.hide();
    });

    // "clear filters" button active state + search-with-filter info banner
    var any_checked = jQuery(
        '.catalogue-filter-item:checked, .solution-types-list input:checked, .product-areas-list input:checked, .screen-sizes-list input:checked, .screen-orientations-list input:checked, .country-list input:checked, .city-list input:checked'
    ).length > 0;

    if (any_checked || search_active) {
        jQuery('.filter-clear').addClass('active');

        if (any_checked && search_active) {
            jQuery('.zd-search-filter-info').show();
        } else {
            jQuery('.zd-search-filter-info').hide();
        }
    } else {
        jQuery('.zd-search-filter-info').hide();
        jQuery('.filter-clear').removeClass('active');
    }

    // Compute which taxonomy values still have visible items, so unmatched
    // filter chips can be dimmed (currently disabled — see commented branch).
    var visible_sets = {
        category: new Set(),
        solution_type: new Set(),
        product_area: new Set(),
        screen_size: new Set(),
        screen_orientation: new Set(),
        country: new Set(),
        city: new Set()
    };

    jQuery('.zd-filter-item:visible').each(function() {
        var el = jQuery(this);

        var add_all = function(vals, set) {
            vals.forEach(function(v) { set.add(String(v)); });
        };

        var split = function(data) {
            if (typeof data === 'string') return data.split(/\s+/).filter(Boolean);
            if (Array.isArray(data)) return data.map(String);
            if (data != null) return String(data).split(/\s+/).filter(Boolean);
            return [];
        };

        add_all(split(el.data('category')), visible_sets.category);
        add_all(split(el.data('solution-type')), visible_sets.solution_type);
        add_all(split(el.data('product-area')), visible_sets.product_area);
        add_all(split(el.data('screen-size')), visible_sets.screen_size);
        add_all(split(el.data('screen-orientation')), visible_sets.screen_orientation);
        add_all(split(el.data('country')), visible_sets.country);
        add_all(split(el.data('city')), visible_sets.city);
    });

    jQuery('li.filter-item').each(function() {
        var $li = jQuery(this);
        var $input = $li.find('.catalogue-filter-item');

        if (!$input.length) return;

        var tax = String($input.data('taxonomy') || '');
        var id = String($input.data('identifier') || '');

        if (tax === 'area') tax = 'product_area';
        if (tax === 'solutions') tax = 'category';
        if (tax === 'zd_asset_country') tax = 'country';
        if (tax === 'zd_asset_city') tax = 'city';

        var set = visible_sets[tax];
        // var has_match = !!(set && set.has(id));  // kept for parity with prior dim-logic

        $li.css('display', 'block');

        if ($input.is(':checked')) {
            $input.prop('disabled', false);
            $li.removeClass('is_dimmed');
        }
        // else branch intentionally disabled — leaves unmatched filters fully active.
    });

    if (!filters_pruned_once) {
        filters_pruned_once = true;
    }

    // Count + sort
    var count = jQuery('.zd-filter-item:visible').length;
    var total = jQuery('.zd-filter-item').length;

    var text = count === 1
        ? '1 item showing out of ' + total
        : count + ' items showing out of ' + total;

    jQuery('.product-search-count').text(text);
    render_catalogue_filter_pills();

    if (count === 0) {
        jQuery('.zd-no-items').prop('hidden', false);
    } else {
        jQuery('.zd-no-items').prop('hidden', true);
    }

    jQuery('.zd-item-catalogue .zd-scroll-top-btn').css('display', count > 12 ? 'block' : 'none');

    var $sort = jQuery('.product-search-sort-select');
    var container = jQuery('.zd-products-list').first();

    if (!$sort.length || !container.length) {
        return;
    }

    var items = container.children().get();
    if (!items.length) {
        return;
    }

    var sort_option = $sort.val();

    if (sort_option === 'name') {
        items.sort(function(a, b) {
            var a_t = jQuery(a).find('.woocommerce-loop-product__title').first().text().trim().toLowerCase();
            var b_t = jQuery(b).find('.woocommerce-loop-product__title').first().text().trim().toLowerCase();
            return a_t.localeCompare(b_t);
        });
    } else {
        items.sort(function(a, b) {
            var a_el = jQuery(a).hasClass('zd-filter-item') ? jQuery(a) : jQuery(a).find('.zd-filter-item').first();
            var b_el = jQuery(b).hasClass('zd-filter-item') ? jQuery(b) : jQuery(b).find('.zd-filter-item').first();

            var a_ts = parseInt((a_el.attr('data-date-added') || jQuery(a).attr('data-date-added') || '0'), 10) || 0;
            var b_ts = parseInt((b_el.attr('data-date-added') || jQuery(b).attr('data-date-added') || '0'), 10) || 0;

            return b_ts - a_ts;
        });
    }

    jQuery(items).detach().appendTo(container);
}

// === URL preset (/shop/solutions/foo → check matching filter) ===

function apply_url_catalogue_preset() {
    var found = false;

    taxonomies.some(function(tax) {
        var regex = new RegExp('^/(?:shop/)?' + tax + '(?:/[^/]+)*/([^/]+)/?$');
        var match = window.location.pathname.match(regex);

        if (!match || !match[1]) return false;

        clear_catalogue_filters(true);

        var slug = match[1];
        var taxonomy = tax;

        if (taxonomy === 'solutions') taxonomy = 'category';
        if (taxonomy === 'area') taxonomy = 'product_area';

        jQuery(
            '.catalogue-filter-item[data-taxonomy="' + taxonomy + '"][data-identifier="' + slug + '"]'
        ).prop('checked', true);

        sync_catalogue_title_from_filters();
        found = true;
        return true;
    });

    return found;
}

// === event wiring ===

function bind_events() {
    jQuery(document).on('input', '#zd-product-search', function(e) {
        e.preventDefault();
        apply_search_filter();
    });

    jQuery(document).on('click', '.zd-filter-pill', function(e) {
        e.preventDefault();
        clear_catalogue_filter_group(jQuery(this).data('filter-taxonomy'));
    });

    jQuery(document).on('click', '.catalogue-filters .filter-clear', function() {
        jQuery(this).removeClass('active');
        clear_catalogue_filters();
    });

    jQuery(document).on('click', '.zd-search-filter-all', function(e) {
        e.preventDefault();
        clear_filters_keep_search();
    });

    jQuery(document).on('click', '.zd-item-catalogue .zd-scroll-top-btn', function(e) {
        e.preventDefault();

        var $catalogueTop = jQuery('a[name="zd-catalogue-top"]').first();

        if ($catalogueTop.length) {
            var target = Math.max(0, $catalogueTop.offset().top - 180);
            jQuery('html, body').animate({ scrollTop: target }, 100);
        } else {
            jQuery('html, body').animate({ scrollTop: 0 }, 100);
        }
    });

    jQuery(document).on('change', 'input.catalogue-filter-item', function() {
        sync_catalogue_filter_pair(jQuery(this));
        sync_catalogue_title_from_filters();
        apply_filters();
    });

    jQuery(document).on('change', '.product-search-sort-select', function() {
        apply_filters();
    });
}

export function init() {
    bootstrap_page_flags();
    bind_events();

    var has_url_preset = apply_url_catalogue_preset();
    var restored_state = !has_url_preset && restore_catalogue_filter_state();

    if (!restored_state && !has_url_preset) {
        jQuery('.zd-filter-item').hide();
    }

    if (restored_state) {
        sync_catalogue_title_from_filters();
    }

    apply_filters(false);
}
